import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const InAppBrowserWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [browserType, setBrowserType] = useState('');

  useEffect(() => {
    // Don't show again if already dismissed this session
    if (sessionStorage.getItem('wwyd_inapp_dismissed')) return;

    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1) {
      setBrowserType('Facebook');
      setShowWarning(true);
    } else if (ua.indexOf('Instagram') > -1) {
      setBrowserType('Instagram');
      setShowWarning(true);
    } else if (ua.indexOf('LinkedInApp') > -1) {
      setBrowserType('LinkedIn');
      setShowWarning(true);
    } else if (ua.indexOf('Twitter') > -1) {
      setBrowserType('Twitter');
      setShowWarning(true);
    } else if (ua.indexOf('wv') > -1) {
      setBrowserType('in-app');
      setShowWarning(true);
    }
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem('wwyd_inapp_dismissed', 'true');
    setShowWarning(false);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = window.location.href;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    handleDismiss();
  };

  if (!showWarning) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -40, opacity: 0 }}
        className="fixed top-16 left-0 right-0 z-40 bg-amber-50 border-b border-amber-200 px-4 py-2.5"
      >
        <div className="max-w-2xl mx-auto flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <svg
              className="w-4 h-4 text-amber-500 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p className="text-sm text-amber-800 truncate">
              {browserType}'s browser may limit some features.{' '}
              <button
                onClick={handleCopyLink}
                className="underline font-medium hover:text-amber-900"
              >
                Copy link
              </button>{' '}
              to open in Safari or Chrome.
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="text-amber-400 hover:text-amber-600 flex-shrink-0"
            aria-label="Dismiss"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InAppBrowserWarning;
